import cn from 'classnames';
import type { OpeningHours } from '../model/types';
import * as style from './OpeningTable.module.css';

export interface Props {
    openingHours: OpeningHours[];
    deviating?: boolean;
}

export default function OpeningsTable({ openingHours, deviating }: Props) {
    if (!openingHours?.length) {
        return null;
    }

    return (
        <div className={cn(style.openingTable, { [style.deviating]: deviating })}>
            {openingHours.map(({ day, hours }) => (
                <div className={style.dayRow} key={day.isoDateFormat}>
                    <div aria-label={day.readableValue}>{day.formattedValue}</div>
                    <div aria-label={hours.readableValue}>{hours.formattedValue}</div>
                </div>
            ))}
        </div>
    );
}
